import CatalogNew from "../catalog/CatalogNew";

/** Cadastro de produtos com regras próprias de estoque, custos e fornecedor. */
const ProductNew = () => <CatalogNew type="PRODUCT" />;

export default ProductNew;
